export const testIds = {
  UNLINK_MODAL_ACCEPT_BUTTON: 'unlink_modal_accept-continue-button',
  UNLINK_MODAL_TABLE: 'unlink_table',
};
